<template>
  <svg
    width="16"
    height="16"
    viewBox="1.5 2.5 13.5 11.5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-4 w-4 shrink-0"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3332 10.668H3.33317C2.4127 10.668 1.6665 9.92178 1.6665 9.0013V4.33464C1.6665 3.41416 2.4127 2.66797 3.33317 2.66797H10.6665C11.587 2.66797 12.3332 3.41416 12.3332 4.33464V5.33464"
      fill="#E2E4EE"
    />
    <rect
      x="3.83301"
      y="4.83594"
      width="11"
      height="9"
      rx="2.5"
      :fill="active ? 'url(#cards_nav_blue)' : 'url(#cards_nav_gray)'"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M14.333 7.5V8.5H4.33301V7.5H14.333Z" fill="white" />
    <path
      d="M7.99984 10.168C8.27598 10.168 8.49984 10.3918 8.49984 10.668C8.49984 10.9441 8.27598 11.168 7.99984 11.168H6.6665C6.39036 11.168 6.1665 10.9441 6.1665 10.668C6.1665 10.3918 6.39036 10.168 6.6665 10.168H7.99984Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="cards_nav_blue"
        x1="4.78753"
        y1="12.336"
        x2="13.0974"
        y2="6.11481"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C7CBFF" />
        <stop offset="1" stop-color="#0012FA" />
      </linearGradient>
      <linearGradient
        id="cards_nav_gray"
        x1="4.78753"
        y1="12.336"
        x2="13.0974"
        y2="6.11481"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D3D5E4" />
        <stop offset="1" stop-color="#585B79" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
defineProps<{
  active?: boolean
}>()
</script>
